import { GridCellProps } from '@progress/kendo-react-grid';
import { flatten } from 'lodash';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';

const ReceiptErrorCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const errorMessages: string[] = useMemo(
    () => flatten(Object.values(dataItem.errors)),
    [dataItem.errors]
  );
  const warningMessages: string[] = useMemo(
    () => flatten(Object.values(dataItem.warnings)),
    [dataItem.warnings]
  );
  const infosMessages: string[] = useMemo(
    () => flatten(Object.values(dataItem.informations)),
    [dataItem.informations]
  );

  return (
    <GridCellBase
      {...props}
      className={`overflow-visible-imp ${getBgColor(
        errorMessages,
        warningMessages,
        infosMessages
      )}`}
      disableToolTip
    >
      <PopUp
        popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'top' }}
        className="max-h-[120px] "
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Information" contents={infosMessages as string[]} />
            <PopUpContentWrapper type="Warning" contents={warningMessages as string[]} />
            <PopUpContentWrapper type="Error" contents={errorMessages as string[]} />
          </div>
        }
      >
        <div className="flex justify-center items-center">
          {getIcon(
            errorMessages as string[],
            warningMessages as string[],
            infosMessages as string[]
          )}
        </div>
      </PopUp>
    </GridCellBase>
  );
};

export default ReceiptErrorCell;
